import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReply = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.42566 3.33914C7.42544 3.1508 7.36849 2.96689 7.26223 2.81138C7.15598 2.65587 7.00535 2.53597 6.82997 2.4673C6.65459 2.39863 6.46259 2.38438 6.27899 2.4264C6.0954 2.46843 5.92871 2.56478 5.80066 2.70289L2.38754 6.39914C2.22783 6.57229 2.13916 6.79921 2.13916 7.03477C2.13916 7.27032 2.22783 7.49725 2.38754 7.67039L5.79879 11.3666C5.92684 11.5048 6.09352 11.6011 6.27712 11.6431C6.46071 11.6852 6.65271 11.6709 6.82809 11.6022C7.00347 11.5336 7.1541 11.4137 7.26036 11.2582C7.36661 11.1026 7.42356 10.9187 7.42379 10.7304V8.90977H9.17379C10.417 8.90977 11.6093 9.40363 12.4884 10.2827C13.3674 11.1618 13.8613 12.3541 13.8613 13.5973V9.84727C13.8613 8.60407 13.3674 7.41178 12.4884 6.53271C11.6093 5.65363 10.417 5.15977 9.17379 5.15977H7.42379L7.42566 3.33914Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgReply;
